module.exports = __webpack_public_path__ + "img/warm-up-outer.7ef9fa24.png";